import { SampleType } from '@resistapp/common/sampling-point-types';

export type ChakraColorScheme = 'gray' | 'red' | 'orange' | 'yellow' | 'green' | 'blue' | 'purple';

export function envTypeToColorScheme(envType: SampleType | string): ChakraColorScheme {
  switch (envType as SampleType) {
    case SampleType.WASTEWATER:
    case SampleType.SURFACE_WATER:
    case SampleType.OTHER_WATER:
      return 'blue';
    case SampleType.SEDIMENT:
    case SampleType.MANURE:
      return 'orange';
    case SampleType.SOIL:
      return 'yellow';
    case SampleType.SLUDGE:
      return 'purple';
    case SampleType.STOOL:
      return 'red';
    case SampleType.FOOD:
      return 'green';
    case SampleType.CONTROL:
    case SampleType.OTHER:
    default:
      return 'gray';
  }
}
